import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (imagePath) => {
  // imagePath may already be "/api/files/..."
  if (!imagePath) return "";
  if (imagePath.startsWith("http")) return imagePath;
  if (imagePath.startsWith("/api")) return `${BACKEND_URL}${imagePath}`;
  return `${API}/files/${imagePath}`;
};

export const adminToken = {
  get: () => localStorage.getItem("wc_admin_token"),
  set: (t) => localStorage.setItem("wc_admin_token", t),
  clear: () => localStorage.removeItem("wc_admin_token"),
};

export const adminHeaders = () => {
  const t = adminToken.get();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
